module.exports = __webpack_public_path__ + "static/media/eye.cb180667.svg";